import UploadProgressBar from 'app/components/UploadProgressBar';

const LogoUploadProgressBar = props => {
  const {
    accessCodePage
  } = props;

  // this fileId matches the one in useAccessCodePageLogoUploadForm
  let fileId = accessCodePage.id + '-logo';

  return <UploadProgressBar {...{ fileId }} />;
}

export default LogoUploadProgressBar;
